import Vue from 'vue'

Vue.filter('unit', value => {
  if (value === null || typeof value === 'undefined') {
    return 0
  }

  return Intl.NumberFormat('en-US').format(value)
})
